import { render, staticRenderFns } from "./trxhistory.vue?vue&type=template&id=236d23eb&"
import script from "./trxhistory.vue?vue&type=script&lang=js&"
export * from "./trxhistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports